import axiosConfig from "./axiosConfig";
import { BillingConfigEntry } from "./getSiteBillingConfig";

export interface CreateBillingConfigEntryRequest {
  esysUuid: string;
  start: string;
  end: string;
  method: string;
  demandScalingFactor?: number;
}

export interface UpdateBillingConfigEntryRequest {
  esysUuid: string;
  start: string;
  end: string;
  method: string;
  demandScalingFactor?: number;
}

export const postSiteBillingConfigEntry = async (
  authToken: string,
  siteId: string,
  request: CreateBillingConfigEntryRequest
): Promise<BillingConfigEntry> => {
  const { data } = await axiosConfig.post(
    `/site/${siteId}/billing_config`,
    request,
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
};

export const putSiteBillingConfigEntry = async (
  authToken: string,
  siteId: string,
  entryId: number,
  request: UpdateBillingConfigEntryRequest
): Promise<BillingConfigEntry> => {
  const { data } = await axiosConfig.put(
    `/site/${siteId}/billing_config/${entryId}`,
    request,
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
};
